<template>
  <orders-base-view status="new"></orders-base-view>
</template>

<script>

import OrdersBaseView from "@/components/orders/OrdersBaseView";
export default {
  name: 'OrdersNewView',

  components: {OrdersBaseView},
};
</script>
